import { md5 } from 'js-md5';
import appSettings from "../utils/AppSetting";

export const EncryptStingMD5 = (str) => {
    if (str !== null && str !== ""){
        return md5.hmac.hex(`${appSettings.auth.Encrypt.secretKey}`, str);
    }
}